<script setup lang="ts">
import { updateorAddMetaTag } from "@/utils/functions";
import { onBeforeUnmount, onMounted } from "vue";

import { defineAsyncComponent } from 'vue';

const Default = defineAsyncComponent(() => import('@/views/layouts/Default.vue'));
const Link = defineAsyncComponent(() => import('@/views/components/Link.vue'));

let metaTag: any;
onMounted(() => {
    metaTag = document.createElement("meta");
    metaTag.name = "robots";
    metaTag.content = "index, follow";
    document.head.appendChild(metaTag);

    document.querySelector('link[rel="canonical"]')?.setAttribute('href', document.location.href);
    updateorAddMetaTag('description', '');
    if (typeof window !== 'undefined') {
        window.scrollTo(0, 0)
    }
})

onBeforeUnmount(() => {
    if (metaTag && document.head.contains(metaTag)) {
        document.head.removeChild(metaTag);
    }
})
</script>

<template>
    <Default>
        <!-- BEGIN: Content-->
        <div class="app-content content pt-5"
            style="min-height:75%; margin-left: 0px; margin-top: 6rem; background-color: white;">
            <main id="main">
                <!-- ======= Breadcrumbs ======= -->
                <section id="breadcrumbs" class="breadcrumbs">
                    <div class="container">
                        <h1>Conditions générales de vente topela</h1>
                    </div>
                </section><!-- End Breadcrumbs -->

                <div class="container">
                    <div class="py-0 h-style h5-style use-poppins"
                        style="font-style: italic;font-size:16px !important;color:black">
                        Mise à jour le 01 septembre 2026.
                    </div>
                </div>

                <section class="py-0 about">
                    <div class="container">
                        <div class="row mb-0">
                            <div
                                class="col-12 icon-boxes d-flex flex-column align-items-stretch justify-content-center ">
                                <span class="h3 h-style h3-style use-poppins mb-3"> Définition </span>
                                <div>
                                    <div class="h4 h-style h4-style use-poppins mb-2">Application Mobile topela</div>
                                    <p>
                                        Désigne l'application mobile (appelée aussi app topela) disponible sur Google
                                        Play et Apple Store,
                                        qui offre aux Utilisateurs Professionnels des Services de mise en relation, de
                                        devis,
                                        de gestion de prestations et de factures pour entrepreneurs.
                                    </p>
                                </div>

                                <div>
                                    <div class="h4 h-style h4-style use-poppins mb-2">Plateforme topela</div>
                                    <p>
                                        Désigne l'ensemble des moyens informatiques mis en œuvre par Webck pour offrir
                                        les Services à ses Utilisateurs Clients et Professionnels (tels que définis
                                        ci-dessous), notamment par la mise à disposition de l'Application Mobile topela
                                        et du Site Web.
                                    </p>
                                </div>

                                <div>
                                    <div class="h4 h-style h4-style use-poppins mb-2">Services</div>
                                    <p>
                                        Désignent les services payants proposés par la Plateforme topela au profit des
                                        Utilisateurs Professionnels.
                                    </p>
                                </div>

                                <div>
                                    <div class="h4 h-style h4-style use-poppins mb-2">Site Web</div>
                                    <p>
                                        Désigne le site Internet mis à la disposition du public par Webck SAS par le
                                        biais d'Internet à l'adresse URL
                                        <a href="https://123topela.fr"
                                            style="text-decoration: underline !important;color:#0070C0 !important;"
                                            target="_blank">https://123topela.fr</a> (ou à l'adresse de l'un ou l'autre
                                        des sous-domaines du site précité).
                                    </p>
                                </div>

                                <div>
                                    <div class="h4 h-style h4-style use-poppins mb-2">Solution</div>
                                    <p>
                                        Désigne l'ensemble des programmes informatiques en code objet et code source, y
                                        compris le support et, le cas échéant, la documentation y afférente, réalisés
                                        par Webck ou ses sous-traitants, permettant à l'Utilisateur, via l'accès à la
                                        Plateforme topela, de bénéficier des Services qui y sont proposés.
                                    </p>
                                </div>

                                <div>
                                    <div class="h4 h-style h4-style use-poppins mb-2">Utilisateur / Utilisateur
                                        Professionnel</div>
                                    <p>
                                        Désigne l'entrepreneur individuel, l'entreprise et/ou la société inscrit(e) au
                                        registre du commerce et des sociétés utilisant les Services par le biais de
                                        l'Application Mobile topela et du Site Web.
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                <section class="py-0 about" style="margin: 0px !important;padding-bottom:0px !important">
                    <div class="container">
                        <div class="row">
                            <div
                                class="col-12 icon-boxes d-flex flex-column align-items-stretch justify-content-center ">
                                <div>
                                    <div class="h3 h-style h3-style use-poppins">1. Objet </div>
                                    <p>
                                        Les présentes conditions générales de vente s'appliquent sans restriction ni
                                        réserves à l'ensemble des Services en ligne payants proposés par la société
                                        Webck (ci-après, le <strong>« Vendeur »</strong> ou <strong>« Webck »</strong>)
                                        sur la Plateforme topela.
                                    </p>
                                    <p>
                                        La Plateforme topela offre un service de bout en bout qui vise à faciliter la
                                        relation d'affaire entre les entrepreneurs et leurs clients. La Plateforme
                                        topela fournit des services (i) à ses utilisateurs clients mais également (ii) à
                                        ses utilisateurs professionnels.
                                        Tandis que les services fournis aux utilisateurs clients sont tous gratuits, les
                                        services fournis aux Utilisateurs Professionnels sont pour partie gratuits et
                                        pour partie payants :
                                    </p>
                                    <div>
                                        <ul>
                                            <li>
                                                Services gratuits fournis à l'Utilisateur Professionnel en tant
                                                qu'inscrit à la Plateforme topela : visibilité de l'Utilisateur sur le
                                                moteur de recherche, consultation des demandes postées par les clients,
                                                utilisation de la messagerie intégrée, bloc-notes, création et
                                                modification de modèles de devis, notifications en temps réel.
                                            </li>
                                            <li>
                                                Services payants fournis à l’Utilisateur Professionnel en tant qu’abonné
                                                à la Plateforme topela : demande de mise en relation sur les annonces
                                                postées par les clients, gestion des devis client, utilisation de la
                                                signature électronique, suivi de prestations, envoi des factures et
                                                avoirs aux clients, export comptable normalisé.
                                            </li>
                                        </ul>
                                    </div>
                                    <p>
                                        Les conditions générales d’utilisation des services fournis à titre gratuits par
                                        Webck à ses utilisateurs clients et
                                        professionnels (<a
                                            style="text-decoration: underline !important;color:#0070C0 !important;"
                                            target="_blanc" href="/general-conditions-of-use">Conditions générales
                                            d’utilisation</a> topela) sont accessibles sur le Site Web et imprimables à
                                        tout moment par un lien direct en bas de la page d’accueil du Site Web.
                                    </p>
                                    <p>
                                        Les présentes conditions générales ont pour objet de définir les modalités et
                                        conditions de la vente en ligne et de la mise à disposition des Services payants
                                        au profit des Utilisateurs Professionnels de la Plateforme topela, ainsi que de
                                        définir les droits et obligations des parties dans ce cadre.
                                    </p>
                                    <p>
                                        Les présentes conditions générales de vente sont accessibles et imprimables à
                                        tout moment par un lien direct en bas de page de la page d’accueil du Site Web,
                                        lien également accessible via le menu général de l’Application Mobile.
                                    </p>
                                    <p>
                                        La version applicable des conditions générales de vente est celle consultable en
                                        ligne sur la Plateforme topela à la date de l’abonnement de l’Utilisateur
                                        Professionnel.
                                    </p>
                                    <p>
                                        Les présentes conditions générales de vente prévalent sur toutes autres
                                        conditions générales ou particulières non expressément agréées par Webck. <br>
                                        Elles peuvent être complétées, le cas échéant, par des conditions d’utilisation
                                        particulières à certains Services. En cas de contradiction, les conditions
                                        particulières prévalent sur ces conditions générales.
                                        Le fait que Webck ne se prévale pas à un moment donné de l'une quelconque des
                                        conditions générales de vente ne peut être interprété comme valant renonciation
                                        à se prévaloir ultérieurement de l'une quelconque desdites conditions.
                                    </p>
                                    <p>
                                        La nullité d'une clause contractuelle n'entraîne pas la nullité des conditions
                                        générales de vente. L'inapplication temporaire ou permanente d'une ou plusieurs
                                        clauses des conditions générales de vente par Webck ne saurait valoir
                                        renonciation de sa part aux autres clauses des conditions générales de vente qui
                                        continuent à produire leurs effets.
                                    </p>
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins">2. Identité du Vendeur et contact
                                    </div>
                                    <p>
                                        La Plateforme topela est exploitée par la société Webck, Société par actions
                                        simplifiée au capital de 25 000 €, immatriculée au RCS de Nanterre sous le n°904
                                        029 014, dont le siège social est situé 6 avenue Edouard Herriot, 92350 LE
                                        PLESSIS-ROBINSON, qui propose les Services à la vente.
                                    </p>
                                    <p>
                                        Webck peut être contactée aux coordonnées suivantes, notamment pour toute
                                        réclamation : <br>
                                        Adresse postale : 6 avenue Edouard Herriot, 92350 LE PLESSIS-ROBINSON. <br>
                                        Téléphone : 06 61 55 37 29. <br>
                                        Adresse électronique : <a
                                            href="mailto:admin@webck.fr"
                                            style="text-decoration: underline;color:#0070C0">admin@webck.fr</a>.
                                    </p>
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins">3. Accès à la Plateforme topela et aux
                                        Services </div>
                                    <div>
                                        La Plateforme topela est accessible aux Utilisateurs professionnels, soit :
                                        <ul>
                                            <li>
                                                A toute personne physique disposant de la pleine capacité juridique pour
                                                s’engager au titre des présentes conditions générales en tant
                                                qu’entrepreneur individuel.
                                            </li>
                                            <li>
                                                A toute personne morale agissant par l’intermédiaire d’une personne
                                                physique disposant de la capacité juridique pour contracter au nom et
                                                pour le compte de la personne morale.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins">4. Acceptation des conditions générales
                                    </div>
                                    <p>
                                        L’acceptation des présentes conditions générales par l’Utilisateur est
                                        matérialisée par une case à cocher dans le formulaire de souscription à
                                        l’abonnement. Cette acceptation ne peut être que pleine et entière. Toute
                                        acceptation sous réserve est considérée comme nulle et non avenue. L’Utilisateur
                                        qui n’accepte pas d’être lié par les présentes conditions générales ne peut pas
                                        souscrire d’abonnement sur la Plateforme topela.
                                    </p>
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins">5. Services fournis après abonnement
                                    </div>
                                    <div>
                                        Après abonnement de l’Utilisateur, Webck s’engage à fournir les Services
                                        suivants :
                                        <ul>
                                            <li>
                                                La fourniture à l’Utilisateur d’un droit d’utilisation de la Solution et
                                                des services payants qui y sont associés sans que cette liste ne soit
                                                limitative (aide à l’établissement de devis, utilisation de la signature
                                                électronique, suivi prestations, envoi des factures et avoirs clients,
                                                notifications) ;
                                            </li>
                                            <li>
                                                La mise à disposition de mises à jour ;
                                            </li>
                                            <li>
                                                L’hébergement de la Solution.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins">6. Modalités d’accès à la Plateforme
                                        topela et disponibilité de la Solution </div>
                                    <div>
                                        <div class="h4 h-style h4-style use-poppins my-1">Description des modalités
                                            d’accès à la Plateforme topela</div>
                                        <p>
                                            La Plateforme topela est accessible par tout Utilisateur en se connectant
                                            sur l’Application Mobile au moyen d’Identifiants (pseudo ou numéro de
                                            téléphone et mot de passe), choisis par l’Utilisateur lors de sa première
                                            connexion à l’Application Mobile.
                                        </p>
                                        <p>
                                            A cet égard, il est précisé que l’Utilisateur est responsable des accès qui
                                            sont gérés par Webck afin de se connecter à la Plateforme topela. Ainsi,
                                            l’Utilisateur supportera seul les conséquences qui pourraient résulter d’une
                                            mauvaise utilisation de la Plateforme topela.
                                        </p>
                                    </div>
                                    <div>
                                        <div class="h4 h-style h4-style use-poppins my-1">Taux de disponibilité de la
                                            Solution</div>
                                        <p>
                                            Webck garantit un accès à la Solution. <br>
                                            L’ensemble des fonctionnalités de la Solution sont accessibles par
                                            l’Utilisateur à tout moment, à l’exception des périodes d’intervention.
                                        </p>
                                    </div>
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins">7. Hébergement</div>
                                    <div>
                                        Webck s’engage à faire ses meilleurs efforts pour que la prestation
                                        d’hébergement de la Solution réponde aux spécifications suivantes :
                                        <ul>
                                            <li>
                                                Un service d’hébergement 7 jours sur 7, 24 heures sur 24, à l’exception
                                                des opérations d’intervention planifiées et des opérations de mise à
                                                jour des serveurs ;
                                            </li>
                                            <li>
                                                Un archivage régulier des données sauvegardées ainsi qu’un lieu de
                                                stockage dans un lieu sécurisé distinct du serveur.
                                            </li>
                                        </ul>
                                    </div>
                                    <p>
                                        L’accès à la Solution peut être occasionnellement suspendu en raison
                                        d’interventions programmées ou urgentes, et nécessaires au bon fonctionnement de
                                        la Solution.
                                    </p>
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins">8. Mises à jour</div>
                                    <p>
                                        Dans le cadre des présentes, Webck assure la mise à jour de la Solution.
                                    </p>
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins">9. Souscription aux Services
                                        accessibles par abonnement</div>
                                    <p>
                                        Avant tout abonnement en ligne, l’Utilisateur peut prendre connaissance des
                                        caractéristiques des Services qui seront fournis après abonnement.
                                    </p>
                                    <p>
                                        Afin de bénéficier des Services payants proposés par la Plateforme topela,
                                        l’Utilisateur doit (i) s’inscrire en remplissant le formulaire prévu à cet effet
                                        et (ii) souscrire un abonnement.
                                    </p>
                                    <div>
                                        <div class="h4 h-style h4-style use-poppins my-2">1. Inscription sur la
                                            Plateforme topela</div>
                                        <p>
                                            Lors de son inscription, l’Utilisateur doit fournir, dans tous les cas,
                                            l’ensemble des informations marquées comme obligatoires. Toute inscription
                                            incomplète ne sera pas validée.
                                        </p>
                                        <p>
                                            L’inscription entraîne automatiquement l’ouverture d’un compte au nom de
                                            l’Utilisateur (ci-après, le <strong>« Compte »</strong>), lui donnant accès
                                            à un espace personnel (ci-après, <strong>l’« Espace Personnel »</strong>)
                                            qui lui permet de gérer l’accès et l’utilisation des Services sous une forme
                                            et selon les moyens techniques que Webck juge les plus appropriés.
                                        </p>
                                        <p>
                                            L’Utilisateur garantit que toutes les informations qu’il donne dans le
                                            formulaire d’inscription sont exactes, à jour et sincères et ne sont
                                            entachées d’aucun caractère trompeur.
                                        </p>
                                        <p>
                                            Il s’engage à mettre à jour ces informations dans son Espace Personnel en
                                            cas de modifications (notamment : changement d’adresse postale), afin
                                            qu’elles correspondent toujours aux critères susvisés.
                                        </p>
                                        <p>
                                            L’Utilisateur est informé et accepte que les informations saisies aux fins
                                            de création ou de mise à jour de son Compte vaillent preuve de son identité.
                                            Les informations saisies par l’Utilisateur l’engagent dès leur validation.
                                        </p>
                                        <p>
                                            L’Utilisateur peut accéder à tout moment à son Espace Personnel après s’être
                                            identifié à l’aide de son identifiant de connexion ainsi que de son mot de
                                            passe.
                                        </p>
                                        <p>
                                            L’Utilisateur s’engage à utiliser personnellement son Compte et à ne
                                            permettre à aucun tiers de l’utiliser à sa place ou pour son compte, sauf à
                                            en supporter l’entière responsabilité.
                                        </p>
                                        <p>
                                            Il est pareillement responsable du maintien de la confidentialité de son
                                            identifiant et de son mot de passe, tout accès à la Plateforme topela à
                                            l’aide de ces derniers étant réputée effectuée par l’Utilisateur. Celui-ci
                                            doit immédiatement contacter Webck aux coordonnées mentionnées à l’article 2
                                            des présentes s’il remarque que son Compte a été utilisé à son insu. Il
                                            reconnaît à Webck le droit de prendre toutes mesures appropriées en pareil
                                            cas.
                                        </p>
                                    </div>
                                    <div>
                                        <div class="h4 h-style h4-style use-poppins my-2">2. Souscription à un
                                            abonnement</div>
                                        <p>
                                            L’Utilisateur a la possibilité de souscrire un abonnement. Un écran présente
                                            les différentes formules d’abonnement disponibles, leurs avantages, leur
                                            durée, leur prix et leurs modalités de paiement. L’Utilisateur n’a aucune
                                            obligation de souscrire un abonnement et peut utiliser la Plateforme topela
                                            dans sa version gratuite.
                                        </p>
                                        <p>
                                            La souscription d’un abonnement ne peut être faite qu’à des fins
                                            professionnelles ce que déclare et reconnaît l’Utilisateur. Le non-respect
                                            par l’Utilisateur de tout ou partie des obligations souscrites aux termes
                                            des présentes conditions générales de vente, et en particulier concernant
                                            tout incident de paiement du prix de l’abonnement, pourra entraîner le droit
                                            pour Webck suspendre l’abonnement de l’Utilisateur jusqu’à la régularisation
                                            de sa situation ou encore de le résilier.
                                        </p>
                                        <p>
                                            Préalablement à la confirmation de sa demande de souscription à
                                            l’abonnement, l’Utilisateur est invité à accepter les termes des présentes
                                            conditions générales de vente. Il est acquis que les conditions générales de
                                            vente applicables sont celles en vigueur au jour de la confirmation de son
                                            abonnement.
                                        </p>
                                        <p>
                                            Pour finaliser sa souscription à un abonnement, l’Utilisateur est invité à
                                            confirmer sa demande puis à procéder à la saisie de son moyen de paiement.
                                        </p>
                                    </div>
                                    <div>
                                        <div class="h4 h-style h4-style use-poppins my-2">3. Activation de l’abonnement
                                        </div>
                                        <p>
                                            Une fois la souscription de son abonnement finalisée par l’Utilisateur, ce
                                            dernier est immédiatement activé et l’Utilisateur peut commencer à utiliser
                                            les Services.
                                        </p>
                                        <p>
                                            Il peut à tout instant retrouver les informations sur son abonnement (prix,
                                            historique des paiements et factures) en accédant à la rubrique « Abonnement
                                            » de l’Application Mobile topela.
                                        </p>
                                    </div>
                                    <div>
                                        <div class="h4 h-style h4-style use-poppins my-2">4. Durée de l’abonnement</div>
                                        <p>
                                            Lors de la souscription à un abonnement, l’Utilisateur est invité à
                                            souscrire suivant le processus rappelé ci-avant. L’Utilisateur déclare avoir
                                            pris connaissance desdites conditions et les accepter.
                                        </p>
                                        <p>
                                            L’abonnement est souscrit pour la durée déterminée indiquée lors de la
                                            souscription, selon la formule choisie par l’Utilisateur.
                                        </p>
                                        <p>
                                            En cas d’abonnement mensuel, l’abonnement est souscrit pour une durée
                                            initiale d’un mois (<strong>« Période Initiale »</strong>). À l’issue de
                                            cette Période Initiale, il est renouvelé par tacite reconduction pour une
                                            durée identique, sauf dénonciation suivant la procédure indiquée ci-après,
                                            avant l’échéance de la période contractuelle en cours.
                                        </p>
                                        <p>
                                            En cas d’abonnement annuel, l’abonnement est souscrit pour une période
                                            courant jusqu’au 31 décembre de l’année civile en cours. Lorsqu’il est
                                            souscrit en cours d’année, la première période d’abonnement court de la date
                                            d’activation jusqu’au 31 décembre de l’année en cours. À compter du 1er
                                            janvier suivant, il est renouvelé par tacite reconduction pour des périodes
                                            successives d’un an, correspondant à l’année civile complète, sauf
                                            dénonciation suivant la procédure indiquée ci-après, avant l’échéance de la
                                            période contractuelle en cours.
                                        </p>
                                        <p>
                                            Si l’Utilisateur abonné n’entend pas renouveler son abonnement ou le
                                            résilier définitivement, il doit envoyer sa demande de
                                            non-renouvellement/résiliation de son abonnement topela depuis la fonction
                                            de résiliation se trouvant
                                            dans la rubrique « Abonnement » de l’Application Mobile topela, ou en
                                            contactant Webck par email envoyé à l'adresse suivante : <a
                                                href="mailto:sav@123topela.fr"
                                                style="text-decoration: underline;color:#0070C0">sav@123topela.fr</a>.
                                        </p>
                                        <p>
                                            Si l’Utilisateur Professionnel abonné a des affaires en cours (devis
                                            envoyés, prestations à venir ou en cours), il lui appartient de mettre fin à
                                            ces activités avant la fin de son abonnement.
                                        </p>
                                        <p>
                                            Une fois l’abonnement résilié, l’Utilisateur Professionnel demeure inscrit à
                                            la Plateforme topela et conserve un accès en consultation à ses affaires
                                            (devis, prestations et factures), mais il ne pourra plus y apporter de
                                            modifications.
                                        </p>
                                        <p>
                                            La résiliation de l’abonnement est réalisée sous 48 heures.
                                        </p>
                                        <p>
                                            Pour l’abonnement mensuel, la résiliation est effective à la fin du mois
                                            calendaire en cours, tout mois d’utilisation des Services démarré étant dû.
                                            Une demande de résiliation envoyée moins de 48 heures avant la fin du mois
                                            en cours sera prise en compte le mois suivant.
                                        </p>
                                        <p>
                                            Pour l’abonnement annuel, la demande de non-renouvellement doit être envoyée
                                            au plus tard 48 heures avant le 31 décembre de l’année en cours. À défaut,
                                            l’abonnement annuel sera renouvelé au 1er janvier pour une nouvelle période
                                            d’un an. Sauf disposition contraire indiquée lors de la souscription,
                                            l’abonnement annuel déjà payé ne donne pas lieu à remboursement en cas de
                                            résiliation en cours d’année.
                                        </p>
                                    </div>
                                </div>
                                <div id="10">
                                    <div class="h3 h-style h3-style use-poppins">10. Prix de l’abonnement et modalités
                                        de paiement</div>
                                    <div>
                                        <div class="h4 h-style h4-style use-poppins my-2">1. Prix</div>
                                        <p>
                                            Le prix de l’abonnement aux Services, mensuel ou annuel selon la formule
                                            choisie par l’Utilisateur, est affiché sur la Plateforme topela et rappelé
                                            lors de la souscription.
                                        </p>
                                        <p>
                                            Il est indiqué en euros, hors taxes (TVA française et autres taxes
                                            applicables en sus). Le prix applicable est ainsi celui affiché sur la
                                            Plateforme topela au moment de l'enregistrement de l’abonnement de
                                            l’Utilisateur.
                                        </p>
                                        <p>
                                            Webck se réserve le droit, à sa libre discrétion et selon des modalités dont
                                            elle sera seule juge, de proposer des offres promotionnelles ou réductions
                                            de prix (exemple : 30 premiers jours d’utilisation offerts).
                                        </p>
                                    </div>
                                    <div>
                                        <div class="h4 h-style h4-style use-poppins my-2">2. Révision</div>
                                        <p>
                                            Les tarifs appliqués sont sujets à ajustement annuel en fonction de
                                            l'inflation. L'indice de référence pour l'ajustement des tarifs sera
                                            l'Indice des Prix à la Consommation (IPC) publié par l’INSEE. Le cas
                                            échéant, l'ajustement des tarifs sera effectif à la date de renouvellement
                                            de l’abonnement, soit à la date anniversaire pour un abonnement mensuel,
                                            soit au 1er janvier pour un abonnement annuel. L’Utilisateur abonné sera
                                            notifié de l'ajustement des tarifs au moins 2 mois avant la date d'entrée en
                                            vigueur de la nouvelle tarification.
                                            En continuant d'utiliser les Services après l'entrée en vigueur des nouveaux
                                            tarifs, l’Utilisateur abonné est réputé avoir accepté les ajustements liés à
                                            l'inflation.
                                        </p>
                                        <p>
                                            Aucun ajustement ne sera effectué si l'indice de référence diminue par
                                            rapport à l'année précédente.
                                        </p>
                                    </div>
                                    <div>
                                        <div class="h4 h-style h4-style use-poppins my-2">3. Modalités de paiement</div>
                                        <p>
                                            L’Utilisateur s’engage à payer le prix de son abonnement.
                                        </p>
                                        <p>
                                            Le prix fixe de l’abonnement est facturé selon la formule choisie par
                                            l’Utilisateur lors de la souscription.
                                        </p>
                                        <p>
                                            Pour l’abonnement mensuel, il est facturé mensuellement et en totalité, le
                                            1er de chaque mois, sauf en ce qui concerne la première échéance.
                                        </p>
                                        <p>
                                            Pour l’abonnement annuel, il est facturé annuellement, sauf en ce qui
                                            concerne la première échéance.
                                        </p>
                                        <p>
                                            La première échéance est facturée au premier jour de l’abonnement ou à
                                            l’issue de la période de gratuité offerte, le cas échéant.
                                            La première échéance est facturée au prorata de la période restant à
                                            courir, correspondant à la période au cours de laquelle est intervenue la
                                            souscription de l’abonnement ou la fin de la période de gratuité, le cas
                                            échéant.
                                        </p>
                                        <div>
                                            Exemple pour un abonnement mensuel :
                                            <ul>
                                                <li>
                                                    L’Utilisateur s’est abonné le 23 juin et a bénéficié d’une période
                                                    de gratuité de 14 jours.
                                                </li>
                                                <li>
                                                   Sa période d’abonnement payante débute le 7 juillet. 
                                                   La première échéance lui est facturée le 7 juillet, au prorata de la période restant à courir jusqu’à la fin du mois de juillet, soit : 
                                                    <br>
                                                    <span style="font-style: italic;margin-left:10px">Première échéance
                                                        = prix fixe mensuel de l’abonnement x ( 25 / 31 )</span>
                                                </li>
                                                <li>
                                                    L’échéance suivante (prix fixe mensuel de l’abonnement) interviendra
                                                    le 1er août, au titre de l’utilisation des Services pour le mois
                                                    d’août, et si l’Utilisateur est toujours abonné à cette date.
                                                </li>
                                                <li>
                                                    Si l'Utilisateur s'abonne le dernier jour du mois, un paiement de
                                                    0,01€ lui sera demandé afin de valider ses coordonnées bancaires.
                                                </li>
                                            </ul>
                                        </div>
                                        <p>
                                            Le règlement de l’abonnement à topela par l’Utilisateur s’effectue en ligne
                                            par carte bancaire. Webck utilise le service de paiement sécurisé fourni par
                                            la plateforme de paiement Payzen de Lyra Network.
                                        </p>
                                        <img :src="'https://lyra.directus.app/assets/fa81c140-29e0-4209-97b8-f72c2b9ac9ee/'"
                                            style="width: 80%; max-width: 200px; height: auto;" class="mb-2">
                                        <p>
                                            La notice relative à la sécurisation des paiements fournie par Lyra Network
                                            est consultable sur : <a
                                                style="text-decoration: underline !important;color:#0070C0 !important;"
                                                target="_blanc"
                                                href="https://www.payzen.eu/pci-dss/">https://www.payzen.eu/pci-dss/</a>.
                                        </p>
                                        <p>
                                            L’Utilisateur garantit à Webck qu'il dispose des autorisations nécessaires
                                            pour utiliser la carte bancaire et s’engage à prendre les mesures
                                            nécessaires afin que le prélèvement du prix de son abonnement puisse être
                                            effectué à défaut de dénonciation avant le terme de la période en cours.
                                        </p>
                                        <p>
                                            Webck se réserve le droit de suspendre ou de résilier l’abonnement de
                                            l’Utilisateur en cas de non-paiement de toute somme qui serait due par ce
                                            dernier, en cas d'incident de paiement, ou en cas de fraude ou tentative de
                                            fraude relative à l’utilisation de la Plateforme topela.
                                        </p>
                                    </div>
                                    <div>
                                        <div class="h4 h-style h4-style use-poppins my-2">4. Modalités de facturation
                                        </div>
                                        <p>
                                            La facture correspondant à chaque paiement effectué par l’Utilisateur peut
                                            être téléchargée via la rubrique « Abonnement » de l’Application Mobile.
                                        </p>
                                    </div>
                                </div>
                                <div id="11">
                                    <div class="h3 h-style h3-style use-poppins">11. Exécution des Services</div>
                                    <div>
                                        <div class="h4 h-style h4-style use-poppins my-2">1. Territoire des Services
                                        </div>
                                        <p>
                                            Les Utilisateurs sont expressément informés que la Plateforme topela ne
                                            propose l’exécution des Services qu’en France Métropolitaine et dans les
                                            DOM/TOM. Les dates et heures affichées sont celles du fuseau horaire de
                                            Paris (GMT+1).
                                        </p>
                                    </div>
                                    <div>
                                        <div class="h4 h-style h4-style use-poppins my-2">2. Mise en place des Services
                                        </div>
                                        <p>
                                            L’Utilisateur bénéficie des Services de la Plateforme topela dès
                                            finalisation de sa souscription à l’abonnement.
                                        </p>
                                    </div>
                                    <div>
                                        <div class="h4 h-style h4-style use-poppins my-2">3. Assistance</div>
                                        <p>
                                            Webck met à disposition de l’Utilisateur Professionnel une assistance
                                            téléphonique tous les jours de 9h à 19h pour répondre à toutes ses questions
                                            sur le fonctionnement de la Plateforme topela.
                                            Le numéro d’appel de l’assistance est accessible directement via la rubrique
                                            « Aide et contact » de l’Application Mobile topela.
                                        </p>
                                    </div>
                                    <div>
                                        <div class="h4 h-style h4-style use-poppins my-2">4. Spécificités liées aux
                                            Services « devis »</div>
                                        <div>
                                            Les Utilisateurs sont informés que :
                                            <ul>
                                                <li>
                                                    Lors de l’édition d’un devis par l’Utilisateur, le calcul des prix
                                                    est réalisé en arrondissant les montants au centième d’euro
                                                    supérieur. Par exemple si le prix toutes taxes comprises d'une unité
                                                    d'œuvre est de 10,365€ compte tenu de l'application d'une TVA à
                                                    5,5%, alors le prix appliqué sera de 10,37€.
                                                </li>
                                                <li>
                                                    L’adresse du client mentionnée sur un devis envoyé par l’Utilisateur
                                                    via la Plateforme topela correspond à l’adresse de réalisation des
                                                    prestations (i.e. adresse de prestation pour des travaux dans le
                                                    bâtiment).
                                                </li>
                                                <li>
                                                    L'envoi de révisions sur un devis par le Client équivaut à un refus
                                                    contractuel de ce devis. Cette action étant irréversible, le devis
                                                    ne pourra plus être accepté.
                                                    L’Utilisateur devra donc, le cas échéant, procéder à l’envoi d’un
                                                    autre devis au client.
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div id="12">
                                    <div class="h3 h-style h3-style use-poppins">12. Données</div>
                                    <p>
                                        L’Utilisateur reconnaît et accepte expressément que les données recueillies sur
                                        la Plateforme topela font foi de la réalité des opérations intervenues dans le
                                        cadre des présentes.
                                    </p>
                                    <p>
                                        L’Utilisateur peut accéder à ces données dans son Espace Personnel de
                                        l’Application Mobile.
                                    </p>
                                </div>
                                <div id="13">
                                    <div class="h3 h-style h3-style use-poppins">13. Sécurité</div>
                                    <div>
                                        Webck s'engage à ce que :
                                        <ul>
                                            <li>
                                                L’accès aux installations et équipements informatiques de Webck soit
                                                protégé de manière à empêcher l’accès non-autorisé par des tiers ;
                                            </li>
                                            <li>
                                                L’infrastructure de la Solution soit protégée par des firewalls et des
                                                systèmes de tracking ;
                                            </li>
                                            <li>
                                                La Solution soit mise à jour régulièrement afin de garantir la sécurité
                                                au niveau applicatif et afin de limiter les failles de sécurité.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div id="14">
                                    <div class="h3 h-style h3-style use-poppins">14. Obligations des Utilisateurs</div>
                                    <p>
                                        Sans préjudice des autres obligations prévues aux présentes, l’Utilisateur
                                        s’engage à respecter les obligations qui suivent :
                                    </p>
                                    <p>
                                        L’Utilisateur s’engage, dans son usage des Services, à respecter les lois et
                                        règlements en vigueur et à ne pas porter atteinte aux droits de tiers ou à
                                        l’ordre public.
                                    </p>
                                    <p>
                                        Il est notamment seul responsable du bon accomplissement de toutes les
                                        formalités notamment administratives, fiscales et/ ou sociales et de tous les
                                        paiements de prestations, taxes ou impôts de toutes natures qui lui incombent,
                                        le cas échéant, en relation avec son utilisation des Services.
                                        La responsabilité de Weck ne pourra en aucun cas être engagée à ce titre.
                                    </p>
                                    <p>
                                        L’Utilisateur reconnaît avoir pris connaissance sur la Plateforme des
                                        caractéristiques et contraintes, notamment techniques, de l’ensemble des
                                        Services.
                                    </p>
                                    <p>
                                        Les Utilisateurs sont seuls responsables du choix et de l’usage qu’ils font des
                                        Services. Il leur appartient de vérifier l’adéquation des Services à leurs
                                        besoins et contraintes spécifiques préalablement à la souscription auxdits
                                        Services.
                                    </p>
                                    <p>
                                        Ils doivent par ailleurs prendre les mesures nécessaires pour sauvegarder par
                                        leurs propres moyens les informations de leur Espace Personnel qu’ils jugent
                                        nécessaires, dont aucune copie ne leur sera fournie.
                                    </p>
                                    <p>
                                        L’Utilisateur est informé et accepte que la mise en œuvre des Services nécessite
                                        qu’il soit connecté à Internet et que la qualité des Services dépend directement
                                        de cette connexion, dont il est seul responsable.
                                    </p>
                                    <p>
                                        L’Utilisateur est également seul responsable des relations qu’il pourra nouer
                                        avec les autres Utilisateurs et des informations qu’il leur communique dans le
                                        cadre des Services.
                                        Il lui appartient d’exercer la prudence et le discernement appropriés dans ces
                                        relations et communications.
                                        L’Utilisateur s’engage en outre, dans ses échanges avec les autres Utilisateurs,
                                        à respecter les règles usuelles de politesse et de courtoisie.
                                    </p>
                                    <p>
                                        L’Utilisateur s’engage à faire un usage strictement personnel des Services. Il
                                        s’interdit en conséquence de céder, concéder ou transférer tout ou partie de ses
                                        droits ou obligations au titre des présentes à un tiers, de quelque manière que
                                        ce soit.
                                    </p>
                                    <p>
                                        L’Utilisateur s’engage à fournir à Webck toutes les informations nécessaires à
                                        la bonne exécution des Services. Plus généralement, l’Utilisateur s’engage à
                                        coopérer activement avec Webck en vue de la bonne exécution des présentes.
                                    </p>
                                    <p>
                                        L’Utilisateur est seul responsable des contenus de toute nature (rédactionnels,
                                        graphiques, audiovisuels ou autres, en ce compris la dénomination et/ou l’image
                                        éventuellement choisies par l’Utilisateur pour l’identifier sur le site) qu’il
                                        diffuse dans le cadre des Services (ci-après désignés : les <strong>« Contenus
                                            »</strong>).
                                    </p>
                                    <p>
                                        Il garantit à Webck qu’il dispose de tous les droits et autorisations
                                        nécessaires à la diffusion de ces Contenus.
                                    </p>
                                    <p>
                                        Il s’engage à ce que lesdits Contenus soient licites, ne portent pas atteinte à
                                        l’ordre public, aux bonnes mœurs ou aux droits de tiers, n’enfreignent aucune
                                        disposition législative ou règlementaire et plus généralement, ne soient
                                        aucunement susceptibles de mettre en jeu la responsabilité civile ou pénale de
                                        Webck.
                                    </p>
                                    <p>
                                        L’Utilisateur n’utilisera aucun contenu comprenant des virus informatiques ou
                                        autre code, dossier ou programme ayant pour objet ou pour effet d’interrompre,
                                        détruire ou limiter le fonctionnement de la Plateforme topela et plus
                                        globalement les matériels et logiciels de la société Webck.
                                    </p>
                                    <p>
                                        L’Utilisateur autorise Webck et concède à cette dernière, pendant toute la durée
                                        de son abonnement, le droit de le référencer en tant que client de Webck sur sa
                                        Plateforme.
                                    </p>
                                </div>
                                <div id="15">
                                    <div class="h3 h-style h3-style use-poppins">15. Garantie des Utilisateurs</div>
                                    <p>
                                        L’Utilisateur garantit Webck contre toutes plaintes, réclamations, actions et/ou
                                        revendications quelconques que Webck pourrait subir du fait de la violation, par
                                        l’Utilisateur de l’une quelconque de ses obligations ou garanties aux termes des
                                        présentes conditions générales.
                                    </p>
                                    <p>
                                        Il s’engage à indemniser Webck de tout préjudice qu’elle subirait et à lui payer
                                        tous les frais, charges et/ou condamnations qu’elle pourrait avoir à supporter
                                        de ce fait.
                                    </p>
                                </div>
                                <div id="16">
                                    <div class="h3 h-style h3-style use-poppins">16. Sanctions des manquements</div>
                                    <div>
                                        En cas de manquement à l’une quelconque des dispositions des présentes
                                        conditions générales ou plus généralement, d’infraction aux lois et règlements
                                        en vigueur par un Utilisateur, Webck se réserve le droit de prendre toute mesure
                                        appropriée et notamment de :
                                        <ul>
                                            <li>
                                                suspendre ou résilier l’abonnement de l’Utilisateur, auteur du
                                                manquement ou de l’infraction, ou y ayant participé,
                                            </li>
                                            <li>
                                                supprimer tout contenu mis en ligne,
                                            </li>
                                            <li>
                                                publier sur le site tout message d’information que Webck jugera utile,
                                            </li>
                                            <li>
                                                avertir toute autorité concernée,
                                            </li>
                                            <li>
                                                engager toute action judiciaire
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div id="17">
                                    <div class="h3 h-style h3-style use-poppins">17. Responsabilité de Webck</div>
                                    <div class="row">
                                        <div class="h6 h-style h6-style use-poppins col-auto">1.</div>
                                        <p class="col">
                                            Webck s’engage à fournir les Services avec diligence et selon les règles de
                                            l’art, étant précisé qu’il pèse sur elle une obligation de moyens, à
                                            l’exclusion de toute obligation de résultat, ce que les Utilisateurs
                                            reconnaissent et acceptent expressément.
                                        </p>
                                    </div>
                                    <div class="row">
                                        <div class="h6 h-style h6-style use-poppins col-auto">2.</div>
                                        <p class="col">
                                            Webck s’engage à procéder régulièrement à des contrôles afin de vérifier le
                                            fonctionnement et l’accessibilité de la Plateforme topela. A ce titre, Webck
                                            se réserve la faculté d’interrompre momentanément l’accès à la Plateforme
                                            topela pour des raisons de maintenance.
                                        </p>
                                    </div>
                                    <div class="row">
                                        <div class="h6 h-style h6-style use-poppins col-auto">3.</div>
                                        <p class="col">
                                            Webck ne fournit à l’Utilisateur aucune garantie quant à l’adaptation des
                                            Services à ses besoins, attentes ou contraintes.
                                        </p>
                                    </div>
                                    <div class="row">
                                        <div class="h6 h-style h6-style use-poppins col-auto">4.</div>
                                        <p class="col">
                                            Webck ne garantit pas non plus la compatibilité de la Plateforme topela avec
                                            tous les navigateurs du marché. De même, Webck ne garantit pas la
                                            comptabilité de l’Application Mobile topela avec tous les smartphones du
                                            marché.
                                        </p>
                                    </div>
                                    <div class="row">
                                        <div class="h6 h-style h6-style use-poppins col-auto">5.</div>
                                        <div class="col">
                                            <p>
                                                La responsabilité de Webck est exclue en cas de préjudice, direct ou
                                                indirect, affectant les biens ou les personnes, subi par l’Utilisateur
                                                ou un tiers, et résultant des cas suivants :<br>
                                                <span style="margin-right:10px">-</span> Négligence ou faute commise par
                                                l’Utilisateur ou par un tiers ;<br>
                                                <span style="margin-right:10px">-</span> Toute utilisation dans des
                                                conditions manifestement non conformes pour l’utilisation des
                                                Services.<br>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="h6 h-style h6-style use-poppins col-auto">6.</div>
                                        <p class="col">
                                            Webck ne pourra être tenue pour responsable de l'inexécution ou du retard
                                            dans l’exécution des Services accessibles sur abonnement du fait de
                                            circonstances qui lui
                                            sont extérieures ou d'un cas de force majeure, étant expressément précisé
                                            que sont considérés comme cas de force majeure, outre ceux qui sont
                                            habituellement retenus par la
                                            jurisprudence des juridictions françaises : les intempéries exceptionnelles,
                                            les catastrophes naturelles, les incendies et inondations, la foudre, les
                                            attentats, les cas
                                            de rupture ou de blocage des réseaux de télécommunication, des moyens de
                                            transport ou des services postaux y compris du fait de grèves,
                                            les dommages provoqués par des virus pour lesquels les moyens de sécurité
                                            existant sur le marché ne permettent pas leur éradication,
                                            ainsi que toute obligation légale ou réglementaire ou d'ordre public imposée
                                            par les autorités compétentes et qui auraient pour effet de modifier
                                            substantiellement les présentes conditions générales.
                                        </p>
                                    </div>
                                    <div class="row">
                                        <div class="h6 h-style h6-style use-poppins col-auto">7.</div>
                                        <p class="col">
                                            En tout état de cause, la responsabilité susceptible d’être encourue par
                                            Webck au titre des présentes est expressément limitée aux seuls dommages
                                            directs avérés subis par les Utilisateurs et dans la limite du prix de
                                            l’abonnement.
                                        </p>
                                    </div>
                                    <div class="row">
                                        <div class="h6 h-style h6-style use-poppins col-auto">8.</div>
                                        <p class="col">
                                            Webck n’a pas connaissance des Contenus mis en ligne par les Utilisateurs
                                            dans le cadre des Services, sur lesquels elle n’effectue aucune modération,
                                            sélection, vérification ou
                                            contrôle d’aucune sorte et à l’égard desquels elle n’intervient qu’en tant
                                            que prestataire d’hébergement
                                        </p>
                                    </div>
                                    <div class="row">
                                        <div class="h6 h-style h6-style use-poppins col-auto">9.</div>
                                        <p class="col">
                                            Il est précisé que Webck n’intervient, à aucun moment, dans les parcours de
                                            relation d’affaire entre les Utilisateurs Clients et Professionnels.
                                        </p>
                                    </div>
                                    <div class="row">
                                        <div class="h6 h-style h6-style use-poppins col-auto">10.</div>
                                        <p class="col">
                                            En conséquence, Webck ne peut être tenue pour responsable des Contenus, dont
                                            les auteurs sont des tiers, toute réclamation éventuelle devant être dirigée
                                            en premier lieu vers l’auteur
                                            des Contenus en question. Webck ne saurait non plus être tenue responsable
                                            des choix réalisés par les Utilisateurs lors de
                                        </p>
                                    </div>
                                    <p>
                                        L’Utilisateur Professionnel sera donc seul et exclusivement responsable de tout
                                        dommage (y compris dommage/préjudice matériel de nature économique ou financière
                                        tel
                                        qu’une perte de client(s), un préjudice financier, un gain manqué, etc.)
                                        résultant de toute erreur ou inexactitude (contenu, information, données,
                                        chiffres, totaux, etc.)
                                        figurant sur tout document (par exemple devis ou factures, etc.) (i) émis par la
                                        Plateforme topela, (ii) envoyé manuellement par l’Utilisateur à ses clients, et
                                        (iii) utilisé
                                        directement ou indirectement par l’Utilisateur Professionnel, par ses clients
                                        et/ou par tout autre tiers. Avant de procéder à tout envoi,
                                        l’Utilisateur Professionnel doit donc vérifier que le contenu des documents émis
                                        via la Plateforme topela et destinés aux Utilisateurs Client est parfaitement
                                        correct.
                                    </p>
                                    <p>
                                        Les Contenus préjudiciables à un tiers peuvent faire l’objet d’une notification
                                        à Webck selon les modalités prévues par l’article 6 I 5 de la
                                        loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique,
                                        Webck se réservant de prendre les mesures décrites à l’article 12.
                                    </p>
                                </div>
                                <div id="18">
                                    <div class="h3 h-style h3-style use-poppins">18. Droits de propriété intellectuelle
                                    </div>
                                    <p>
                                        Les systèmes, logiciels, structures, infrastructures, bases de données et
                                        contenus de toute nature (textes, images animées ou non, visuels, musiques,
                                        logos,
                                        marques, base de données, structure générale des fonctionnalités, savoir-faire
                                        etc.) exploités par Webck au sein de la Plateforme topela sont protégés par tous
                                        droits de propriété intellectuelle ou droits des producteurs de bases de données
                                        en vigueur. Tous désassemblages, décompilations, décryptages, extractions,
                                        réutilisations,
                                        copies et plus généralement, tous actes de reproduction, représentation,
                                        diffusion et utilisation de
                                        l’un quelconque de ces éléments, en tout ou partie, sans l’autorisation de Webck
                                        sont strictement interdits et pourront faire l’objet de poursuites judiciaires.
                                    </p>
                                    <p>
                                        Pendant la durée de l’abonnement, Webck concède à l’Utilisateur, qui l’accepte,
                                        un droit personnel, non exclusif et incessible d’utilisation de la Solution, au
                                        titre des
                                        besoins et périmètre tels qu’indiqués lors de la souscription de l’abonnement.
                                    </p>
                                    <p>
                                        Cette licence d’utilisation est consentie pour toute la durée de protection des
                                        éléments constitutifs de la Solution par le droit d’auteur, pour le monde
                                        entier, sans autre rémunération que le prix de l’abonnement.
                                    </p>
                                    <p>
                                        L’Utilisateur s’engage à ne pas outrepasser les droits qui lui seront concédés
                                        aux termes des présentes conditions.
                                    </p>
                                </div>
                                <div id="19">
                                    <div class="h3 h-style h3-style use-poppins">19. Données à caractère personnel</div>
                                    <p>
                                        Webck pratique une politique de protection des données personnelles dont les
                                        caractéristiques sont explicitées dans le document intitulé <a
                                            href="/privacy-policy" target="_blanc"
                                            style="text-decoration: underline !important;color:#0070C0 !important;">«
                                            Politique de confidentialité »</a>,
                                        dont l’Utilisateur est expressément invité à prendre connaissance sur le Site
                                        Web.
                                    </p>
                                </div>
                                <div id="20">
                                    <div class="h3 h-style h3-style use-poppins">20. Liens et sites tiers</div>
                                    <p>
                                        Webck ne pourra en aucun cas être tenue pour responsable de la disponibilité
                                        technique de sites internet ou d’applications mobiles exploités par des tiers (y
                                        compris ses éventuels partenaires)
                                        auxquels l’Utilisateur accéderait par l'intermédiaire de la Plateforme.
                                    </p>
                                    <p>
                                        Webck n'endosse aucune responsabilité au titre des contenus, publicités,
                                        produits et/ou services disponibles sur de tels sites et applications mobiles
                                        tiers dont il est rappelé qu’ils sont régis par leurs propres conditions
                                        d’utilisation.
                                    </p>
                                </div>
                                <div id="21">
                                    <div class="h3 h-style h3-style use-poppins">21. Désinscription</div>
                                    <p>
                                        Après avoir mis un terme à son abonnement conformément à la procédure de
                                        résiliation/non-renouvellement prévue à l’article 9.4 ci-avant,
                                        l’Utilisateur peut se désinscrire de tous les services fournis par la Plateforme
                                        topela en adressant un email à l’adresse suivante : <a
                                            href="mailto:sav@123topela.fr"
                                            style="text-decoration: underline;color:blue">sav@123topela.fr</a>.
                                    </p>
                                    <p>
                                        Les modalités de la désinscription (désactivation) sont précisées en article 4
                                        de notre <a
                                            style="text-decoration: underline !important;color:#0070C0 !important;"
                                            target="_blanc" href="/privacy-policy">Politique de confidentialité</a>.
                                    </p>
                                </div>
                                <div id="22">
                                    <div class="h3 h-style h3-style use-poppins">22. Modifications</div>
                                    <p>
                                        Webck se réserve la faculté de modifier à tout moment les présentes conditions
                                        générales de vente. Dans ce cas, les conditions applicables seront celles en
                                        vigueur à la date de souscription de l’abonnement par l’utilisateur.
                                    </p>
                                </div>
                                <div id="23">
                                    <div class="h3 h-style h3-style use-poppins">23. Langue</div>
                                    <p>
                                        Les présentes conditions générales de vente sont rédigées en langue française.
                                    </p>
                                    <p>
                                        Dans l’hypothèse d’une traduction des présentes conditions générales dans une ou
                                        plusieurs langues, la langue d’interprétation sera la langue française en cas de
                                        contradiction ou de contestation sur la signification d’un terme ou d’une
                                        disposition.
                                    </p>
                                </div>
                                <div id="24" class="mb-5">
                                    <div class="h3 h-style h3-style use-poppins">24. Droit applicable et juridiction
                                    </div>
                                    <p>
                                        Les présentes conditions générales de vente sont régies et soumises au droit
                                        français.
                                    </p>
                                    <p>
                                        En cas de contestation sur la validité, l’interprétation et/ou l’exécution des
                                        présentes conditions générales, les parties conviennent que les tribunaux de
                                        Paris seront exclusivement compétents pour en juger, sauf règles de procédure
                                        impératives contraires.
                                    </p>
                                </div>
                                <div id="old_versions" class="mb-5">
                                    <div class="h3 h-style h3-style use-poppins">Versions antérieures</div>
                                    <div>
                                        <ul>
                                            <li>
                                                <Link href="/general-conditions-of-sale/v2025-07-04/" target="_blank"
                                                    style="text-decoration: underline !important; color: rgb(0, 112, 192) !important;">
                                                    Version du 4 juillet 2025
                                                </Link>
                                            </li>
                                            <li>
                                                <Link href="/general-conditions-of-sale/v2025-05-12/" target="_blank"
                                                    style="text-decoration: underline !important; color: rgb(0, 112, 192) !important;">
                                                    Version du 12 mai 2025
                                                </Link>
                                            </li>
                                            <li>
                                                <Link href="/general-conditions-of-sale/v2025-03-18/" target="_blank"
                                                    style="text-decoration: underline !important; color: rgb(0, 112, 192) !important;">
                                                    Version du 18 mars 2025
                                                </Link>
                                            </li>
                                            <li>
                                                <Link href="/general-conditions-of-sale/v2024-10-10/" target="_blank"
                                                    style="text-decoration: underline !important; color: rgb(0, 112, 192) !important;">
                                                    Version du 10 octobre 2024
                                                </Link>
                                            </li>
                                            <li>
                                                <Link href="/general-conditions-of-sale/v2024-08-01/" target="_blank"
                                                    style="text-decoration: underline !important; color: rgb(0, 112, 192) !important;">
                                                    Version du 1er août 2024
                                                </Link>
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="mt-5"></div> -->
                </section>
            </main>
        </div>
    </Default>
</template>

<style scoped>
body {
    font-family: "Century Gothic", sans-serif;
    color: #233648;
}

p {
    color: rgb(75, 75, 75);
    margin-top: 0;
    margin-bottom: 0.5rem;
}

ul li {
    list-style: disc;
}

h3,
.h3 {
    font-size: 20px !important;
    margin-bottom: 0.5rem !important;
    margin-top: 15px !important;
}

h4 {
    font-size: 16px !important;
    margin-bottom: 0.2rem !important;
}

.h4 {
    font-size: 16px !important;
    color: #7f6d68;
    margin-bottom: 0.2rem !important;
}

.h3 {
    font-weight: bold;
}
</style>